export enum AUTHORISATION_HISTORY_ACTION {
  REQUESTED_AUTHORISATION = 'requested_authorisation',
  AUTHORISED = 'authorised',
  REJECTED = 'rejected',
  REOPENED = 'reopened',
  REMOVED = 'removed',
  ADDED = 'added',
  CANCELLED_REQUEST = 'cancelled_request',
  CANCELLED_TASK = 'cancelled_task',
  MADE_READY = 'made_ready',
  TRANSFER_OWNERSHIP = 'transfer_ownership'
}

export const AUTHORISATION_ACTION_CONFIG = {
  [AUTHORISATION_HISTORY_ACTION.REQUESTED_AUTHORISATION]: {
    label: 'POPUPS.START_AUTHORIZATION_LABEL',
    color: 'accent',
    userLabel: 'SIDEBAR.RAISED_BY_LABEL'
  },
  [AUTHORISATION_HISTORY_ACTION.AUTHORISED]: {
    label: 'POPUPS.AUTHORISATION_AUTHORISED',
    color: 'green'
  },
  [AUTHORISATION_HISTORY_ACTION.REJECTED]: {
    label: 'POPUPS.AUTHORISATION_REJECTED',
    color: 'warn'
  },
  [AUTHORISATION_HISTORY_ACTION.REOPENED]: {
    label: 'POPUPS.REOPEN_TASK_LABEL',
    color: 'cerulean',
    needTransition: true,
    transitionConfig: {
      from: 'POPUPS.AUTHORISATION_REJECTED',
      to: 'POPUPS.AUTHORISATION_PENDING',
      fromColor: 'warn',
      toColor: 'yellow'
    }
  },
  [AUTHORISATION_HISTORY_ACTION.REMOVED]: {
    label: 'POPUPS.REMOVED_AUTHORIZER_LABEL',
    color: 'warn',
    targetLabel: 'POPUPS.REMOVE_AUTHORIZER_TITLE'
  },
  [AUTHORISATION_HISTORY_ACTION.ADDED]: {
    label: 'POPUPS.AUTHORIZER_ADD_LABEL',
    color: 'cerulean',
    targetLabel: 'POPUPS.NEW_AUTHORIZER_LABEL'
  },
  [AUTHORISATION_HISTORY_ACTION.CANCELLED_REQUEST]: {
    label: 'POPUPS.CANCELLED_REQUEST_LABEL',
    color: 'warn'
  },
  [AUTHORISATION_HISTORY_ACTION.CANCELLED_TASK]: {
    label: 'POPUPS.CANCELLED_TASK_LABEL',
    color: 'warn'
  },
  [AUTHORISATION_HISTORY_ACTION.MADE_READY]: {
    label: 'POPUPS.FINISH_AUTHORIZATION_LABEL',
    color: 'green',
    skipUser: true
  },
  [AUTHORISATION_HISTORY_ACTION.TRANSFER_OWNERSHIP]: {
    label: 'POPUPS.OWNER_CHANGER_LABEL',
    color: 'accent',
    targetLabel: 'POPUPS.NEW_OWNER_LABEL'
  }
};
